import React, {useContext} from "react";
import {Button, Modal} from "react-bootstrap";
import {TranslateContext} from "../../../../context/TranslateContext";
import Translate from "../../../../components/Translate";

export default function ModalAnteprimaExport({
                                                 show,
                                                 handleClose,
                                                 containerRef,
                                                 handlerDownload
                                             }) {

    const {translate} = useContext(TranslateContext);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <Modal.Header
                className={'ns-modal-header'}
                closeVariant='white'
                closeButton>
                <Modal.Title>{translate("Anteprima documento")}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div
                    id={"anteprimaDoc"}
                    className={"sost-anteprima-doc"}
                    ref={containerRef}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handlerDownload}>
                    <Translate>Scarica</Translate>
                </Button>
            </Modal.Footer>
        </Modal>
    );
}